/** Espelha `MenuItem` do Angular; only-data (sem os setters fluentes). */
export interface MenuItem {
  path: string;
  title: string;
  icon: string;
  class: string;
  badge: string;
  badgeClass: string;
  isExternalLink: boolean;
  submenu: MenuItem[];
  tenant: boolean;
  show: boolean;
  pointAttention: boolean;
  newFeature: boolean;
}

/**
 * Fábrica com os mesmos defaults do construtor do `MenuItem` Angular: `show` é
 * `true` por padrão (assim como no construtor), e `badge` não é parametrizável
 * (fica sempre `''`, como no campo da classe original).
 */
export function menuItem(partial: Partial<MenuItem> & { title: string }): MenuItem {
  return {
    path: partial.path ?? '',
    title: partial.title,
    icon: partial.icon ?? '',
    class: partial.class ?? '',
    badge: '',
    badgeClass: partial.badgeClass ?? '',
    isExternalLink: partial.isExternalLink ?? false,
    submenu: partial.submenu ?? [],
    tenant: partial.tenant ?? false,
    show: partial.show ?? true,
    pointAttention: partial.pointAttention ?? false,
    newFeature: partial.newFeature ?? false,
  };
}
